export enum UnhireTypeEnum {
  HIREINFUTURE = 'hireInFuture',
  REMOVEFOREVER = 'removeForever',
}

export enum TerminationTypeEnum {
  VOLUNTARY = 'VOLUNTARY',
  INVOLUNTARY = 'INVOLUNTARY',
}

export enum TerminationReasonEnum {
  END_OF_CONTRACT = 'END_OF_CONTRACT',
  OTHERS = 'OTHERS',
}
